import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Modal } from 'components/Modal/Modal'
import { createAttendanceReport } from 'features/attendance/attendanceSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const CreateReportModal = ({ closeModal }) => {

    const [state, setState] = useState({
        dateFrom: null,
        dateTo: null,
    })

    const dispatch = useDispatch<AppDispatch>()

    const handleSave = async () => {
        const resp = await dispatch(createAttendanceReport(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column gap='3rem' center>
            <Flex column between center gap='1rem' width='100%'>
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Create Report</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>

                <Flex between gap='1rem' width='100%' >
                    <CalendarInput width='100%' labelText='Date From' nomarg defaultValue={state.dateFrom} onChange={d => setState(prev => ({ ...prev, dateFrom: d }))} maxDate={state.dateTo} />
                    <CalendarInput width='100%' labelText='Date To' nomarg defaultValue={state.dateTo} onChange={d => setState(prev => ({ ...prev, dateTo: d }))} minDate={state.dateFrom} />
                </Flex>
            </Flex>

            <Button disabled={!state.dateFrom || !state.dateTo} orange onClick={handleSave}>
                Save
            </Button>
        </Flex>
    </Modal>
}